import { defineComponent as m, useCssModule as _, ref as f, computed as h, createElementBlock as p, openBlock as e, normalizeClass as i, unref as s, renderSlot as v, withDirectives as x, createBlock as c, withCtx as C, createTextVNode as k, toDisplayString as w } from "vue";
import { UI_TIMEOUT as T } from "./constants.js";
import b from "./directives/tooltip.js";
import { t as n } from "./locale.js";
import g from "./Button.js";
import r from "./Icon.js";
import { _ as B } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const M = /* @__PURE__ */ m({
  __name: "Copy",
  props: {
    text: { default: void 0 },
    value: { default: "" },
    visible: { type: Boolean, default: !1 }
  },
  setup(d) {
    const t = d, a = _(), o = f(!1), y = h(() => o.value ? n("ll.copy.copied") : t.text ? null : n("ll.copy.copyToClipboard"));
    function l() {
      navigator.clipboard.writeText(t.value), o.value = !0, setTimeout(() => {
        o.value = !1;
      }, T);
    }
    return (u, S) => (e(), p("div", {
      class: i(["stash-copy tw-flex tw-items-center", { [s(a).hidden]: !t.visible }]),
      "data-test": "stash-copy"
    }, [
      v(u.$slots, "default"),
      x((e(), p("div", {
        class: i(["stash-copy__copy-zone tw-ml-3 tw-cursor-pointer", s(a).copy]),
        "data-test": "stash-copy|copy-zone"
      }, [
        o.value ? (e(), c(r, {
          key: 0,
          class: "stash-copy__success-icon tw-text-green-500",
          name: "circle-check",
          "data-test": "stash-copy|success-icon"
        })) : t.text ? (e(), c(g, {
          key: 1,
          class: "stash-copy__copy-text",
          inline: "",
          "data-test": "stash-copy|copy-target",
          onClick: l
        }, {
          default: C(() => [
            k(w(t.text), 1)
          ]),
          _: 1
        })) : (e(), c(r, {
          key: 2,
          class: "stash-copy__copy-icon",
          name: "copy",
          title: "Copy to clipboard",
          "data-test": "stash-copy|copy-target",
          onClick: l
        }))
      ], 2)), [
        [
          s(b),
          y.value,
          void 0,
          { top: !0 }
        ]
      ])
    ], 2));
  }
}), z = "_hidden_lkmi6_2", I = "_copy_lkmi6_3", D = {
  hidden: z,
  copy: I
}, E = {
  $style: D
}, A = /* @__PURE__ */ B(M, [["__cssModules", E]]);
export {
  A as default
};
//# sourceMappingURL=Copy.js.map
